import { Injectable, signal } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { ActiveDirectoryAbstraction } from "@shared-core/abstractions/active-directory.abstraction";
import { IBaseDirectory } from "@shared-core/interfaces/base-directory.interface";

@Injectable({ providedIn: "root" })
export class ActiveDirectoryService extends ActiveDirectoryAbstraction {
  readonly activeDirectory = signal<IBaseDirectory | null>(null);
  readonly availableDirectories = signal<IBaseDirectory[]>([]);

  changeActiveDirectory(_id: string): Observable<IBaseDirectory | null> {
    return EMPTY;
  }
}
